<template>
    <span>{{ value }}</span>
</template>

<script setup>

import { defineProps, computed } from 'vue'

const props = defineProps({
    header: { type: Object, required: true },
    item: { type: Object, required: true },
})

const value = computed(() => {
    
    if (props.header.rule) {
        const rawValue = getNestedValue(props.item, props.header.value);
        return applyRule(props.item, rawValue, props.header.rule);
    } else {
        return '';
    }
})

/**
 * Função para obter o valor aninhado de um objeto com base em um caminho fornecido.
 */
function getNestedValue(obj, path) {

    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
}

function applyRule(item, array, rule, separator = ', ') {

  const [action, field] = rule.split(':');

  if (action === 'implode') {

    return array.map(item => item[field]).join(separator);

  }

  if (action === 'concat') {

    const keys = field.split(',').map(k => k.trim());
    const values = keys.map(key => getNestedValue(props.item, key) ?? '');

    return values.join(' - ');

  }

  throw new Error(`Regra não suportada. Ação: ${action} e campo: ${field}`);
}

</script>